import { ApplicationElement, html } from '@crossiety/lit-components';
import copyToClipboard from '@effectivastudio/copy_to_clipboard';
import Snack from '@effectivastudio/snackbar/dist/snackbar.modern.js';
import '@crossiety/lit-components/components/icon/element.js';
import translations from './translations.js';
import style from './style.lit.css';

/**
 * Component allows you to display and copy link.
 *
 * @prop value - Content text
 */

export default class CopyBox extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  /** @internal */
  static translations = translations;

  static properties = {
    strValue: { type: String },
    icon: { type: String },
  };

  constructor() {
    super();
    this.icon = 'copy';
  }

  copy() {
    copyToClipboard(this.strValue);
  }

  showSnack() {
    Snack({
      text: this.t('snack.copied'),
      customClass: 'snackbar-default',
    });
  }

  handleClick() {
    this.copy();
    this.showSnack();
  }

  render() {
    return html`
      <input
        value=${this.strValue}
        readonly
        size="50"
        aria-label="copy input" />
      <button @click=${this.handleClick} aria-label="copy">
        <ef-icon name=${this.icon}></ef-icon>
      </button>
    `;
  }
}

CopyBox.registerTagName('xs-copy-box');

customElements.get('xs-copy-box') ||
  customElements.define('xs-copy-box', CopyBox);
